import React, { useEffect, useState } from 'react';
import '../../assets/styles/header-light.css';
import { Link, useHistory } from 'react-router-dom';
import Bolt from '../../assets/images/bolt.png';
import { redirectToLogout } from '../api/common';
import { getAuthState, setAuthState } from '../../assets/scripts/login-util';
import { logoutAPI } from '../api/agentAPI';
import { getLicenses, getEntitlements, getSubscription, getUsageSummary } from '../api/billingAPI';
import { adaptUsageSummary, usagePercent, isOverQuota, formatBytes } from './usageAdapter';
import swal from "sweetalert2";
import './header.css';
import { dashboardPeriods } from '../../assets/scripts/periodSelection';
import NotificationPanel from './notificationPanel';
import moment from 'moment';
import LicenseChangeReminder from './LicenseChangeReminder';
import { ProfileIcon, SupportIcon, BillingIcon, UsageIcon } from "./headerIcons";

/**
 * Shown wherever a seat-limited action is blocked - out of seats to add a
 * team member (`from='teams'`, teams.js), or below the plan's licence
 * floor (every other call site, no `from`). Laid out after
 * ideas/license_modal.png, but in the app's own light palette (see
 * header.css's .lic-req rules) rather than that reference's dark surface.
 *
 * PHASE 8 already replaced the old "email a human for more licences" flow
 * with a straight link to the licences screen where they can be bought
 * (postAgentLicenseExtension is gone from here entirely now - it was
 * already dead code, unreferenced by this component's own render).
 *
 * `licenses.includedLicenses` (GET /getLicenses, the same seat-count
 * source licenseManager.js/teams.js use) is fetched fresh on open so the
 * "Your current plan includes N licence(s)" line is never a stale/
 * hardcoded number.
 */
export const LicenseModal = (props) => {

    const [licenses, setLicenses] = useState(null);

	useEffect(() => {
		$('#license-modal').modal({
			backdrop: 'static',
		});
		$('#license-modal').on('hidden.bs.modal', function () {
			$('.modal').hasClass('show') && $('body').addClass('modal-open');
			props.onDismissModal();
		});
		getLicenses().then(setLicenses).catch(() => {});
	}, [])

	const isTeams = props.from === 'teams';
	const heading = isTeams ? 'Add a licence to continue' : 'More licences required';
	const text    = isTeams
		? 'Your workspace has reached its licence limit. Add a licence to invite more team members.'
		: 'Your plan does not have enough licences for this. Add licences to continue.';

	return (
        <div
			className="modal fade"
			id="license-modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true">

          	<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content lic-req">
					<div className="lic-req__header">
						<h5 className="lic-req__title">Licence required</h5>
						<button
						  	style={{display:"contents"}}
							type="button"
							className="lic-req__close"
							data-dismiss="modal"
							aria-label="Close">
							<i className="la la-close"></i>
						</button>
					</div>
					<div className="lic-req__body">
						<span className="lic-req__icon"><i className="la la-clock-o"></i></span>
						<h4 className="lic-req__heading">{heading}</h4>
						<p className="lic-req__text">{text}</p>
						{licenses && licenses.includedLicenses != null && (
							<div className="lic-req__info">
								<i className="la la-info-circle"></i>
								<span>
									Your current plan includes {licenses.includedLicenses} licence
									{licenses.includedLicenses === 1 ? '' : 's'}.
								</span>
							</div>
						)}
					</div>
					<div className="lic-req__footer">
						<button type="button" className="lic-req__later" data-dismiss="modal">
							Maybe later
						</button>
						<button type="button" className="lic-req__buy" onClick={() => { window.location.href = '/billing/licenses'; }}>
							Buy licences
						</button>
					</div>
            	</div>
          	</div>
        </div>
	);
}

const header = (props) => {
	const { notificationsList, setrefetchNotifications } = props;

	const history                                    					= useHistory();
	const [username,            		setUsername]       	 			= useState('User');
	const [fullName,            		setFullName]       	 			= useState('');
	const [email,               		setEmail]          	 			= useState('');
	const [companyName,         		setCompanyName]    	 			= useState('');
	const [profilePhoto,        		setProfilePhoto]   	 			= useState(null);
	const [isAdmin,             		setisAdmin]       	 			= useState(false);
	const [showNotification,  			setshowNotification] 			= useState(false);
	const [newAlertCount, 				setNewAlertCount]	 			= useState(0);
	const [showLicenseModal, 			setShowLicenseModal] 			= useState(false);
	const [showLicenseChangeReminder, 	setShowLicenseChangeReminder]  = useState(false);
	const [subscription,        		setSubscription]      			= useState(null);
	const [usage,               		setUsage]              		= useState(null);

	useEffect(() => {
		setuserData();
	},[])

	/**
	 * Task 6: replaces the legacy cookieChange listener that used to read
	 * the licenseReduced flag off the ibAgent cookie (sourced from
	 * TempSubscription/LicenseReminder) and open LicenseChangeReminder.
	 * Checked directly against the new system instead, once per header
	 * mount, same owner-only scope the cookie listener had.
	 *
	 * NOTE what this deliberately does NOT do any more: it used to also
	 * check `licenses.available <= 0` here and open LicenseModal
	 * ("Add a licence to continue") on every single page load. That was
	 * wrong - a tenant simply USING their plan's exact seat count (e.g.
	 * "1 of 1 licence", completely normal for a one-seat plan) tripped it
	 * on every mount, not just when they were actually trying to add
	 * someone. LicenseModal's real, correct trigger points are reactive -
	 * team/teams.js's checkAgentLicence() (clicking "New Member") and
	 * team/TeamMembers.js (clicking a deactivated member) - both check
	 * getLicenses().available at the moment of the blocked action, which
	 * is the only time "no seats left" is actually something to act on.
	 */
	useEffect(() => {
		const authUser = getAuthState('user');
		if (!authUser || Number(authUser.categoryId) !== 1) return;

		let cancelled = false;
		(async () => {
			try {
				const entitlements = await getEntitlements();
				if (cancelled) return;
				if (entitlements.licenseReduced) {
					setShowLicenseChangeReminder(true);
				}
			} catch (err) {
				// Silent - same as SubscriptionBanner's own fetch. A failed
				// check here should never block the rest of the header.
			}
		})();
		return () => { cancelled = true; };
	}, [])

	/**
	 * Task 39: Current Plan + Usage section in the username dropdown.
	 * Same owner-only gating as the entitlements effect above - checked
	 * directly against getAuthState('user') rather than the isAdmin state,
	 * since isAdmin is only set asynchronously inside setuserData() and may
	 * not have resolved yet when this effect runs on mount.
	 *
	 * Task 40: extracted out of the mount effect so it can also be called
	 * every time the dropdown is opened (see the show.bs.dropdown listener
	 * below) - the header never unmounts, so a mount-only fetch went stale
	 * as soon as the tenant's usage changed later in the session.
	 */
	const fetchPlanAndUsage = () => {
		const authUser = getAuthState('user');
		if (!authUser || Number(authUser.categoryId) !== 1) return;

		Promise.all([getSubscription(), getUsageSummary()])
			.then(([subResponse, usageResponse]) => {
				if (subResponse && subResponse.subscription) {
					setSubscription(subResponse.subscription);
				}
				setUsage(adaptUsageSummary(usageResponse));
			})
			.catch(() => {
				// Silent - same convention as the entitlements effect above.
			});
	};

	useEffect(() => {
		fetchPlanAndUsage();
	}, [])

	useEffect(() => {
		$('#kt-header-user-dropdown').on('show.bs.dropdown', fetchPlanAndUsage);
		return () => {
			$('#kt-header-user-dropdown').off('show.bs.dropdown', fetchPlanAndUsage);
		};
	}, [])

	useEffect(() => {document.title = props.title}, [props.title])

	//To Set UnRead Count 
	useEffect(() => {
		if(notificationsList.length > 0){
			const unReadCount = notificationsList.filter( n =>  !n.Read ).length;
			setNewAlertCount(unReadCount);
		}
	},[notificationsList])

	const setuserData = (event) => {
		const cData = getAuthState();
		const { user } = cData;
		if (!user && event) return;
		if(!user) return redirectToLogout();

		setUsername(user.firstName);
		setFullName(user.firstName + ' ' + user.lastName);
		setEmail(user.email);
		if(user.profilePhoto != '') setProfilePhoto(user.profilePhoto);
		if(user.categoryId == 1) setisAdmin(true);
		if (user.companyName) setCompanyName(user.companyName);

		return cData;
	}

	const changePeriodHandler = ({ target }) => {
		const period = dashboardPeriods.find(p => p.id == target.value)
		props.setCurrentPeriod(period);
	}

	const logout = async () => {
		try {
			await logoutAPI()	
			setAuthState();
			window.open('/', '_self');
		} catch (err) {
			window.open('/', '_self');
			swal.fire({
				icon              : "error",
				titleText         : "Error!",
				text              :  err.message,
				buttonsStyling    : false,
				confirmButtonClass: "btn btn-brand",
			});
		}
	};

	const showQuickModal = (action) => {
		if (action === 'client')
			props.onOpenModal(action, true, '', '', '', {type: 'both'})
		else
			props.onOpenModal(action, true);
	};

	const navigateTo = (path) => {
		history.push(path);
	};

	const openSearchPolicyHandler = async () => {
		try {
		props.onOpenModal('searchPolicy', true, '', false);
		} catch (err) {
			swal.fire({
				icon              : "error",
				titleText         : "Error!",
				text              :  err.message,
				buttonsStyling    : false,
				confirmButtonClass: "btn btn-brand",
			});
		}
	}

	const closeDrawerHandler = () => {   
		setrefetchNotifications(true);     
		setTimeout(() => {
			setshowNotification(false);
		}, 180);
	};

	const MenuItem = ({ to, title, icon }) => (
		<Link to={to} className="kt-notification__item padding-tb10">
			<div className="kt-notification__item-icon">
				{icon}
			</div>

			<div className="kt-notification__item-details">
				<div className="kt-notification__item-title">
					{title}
				</div>
			</div>
		</Link>
	);
	

  	let classes = 'kt-header kt-grid__item  kt-header--fixed header-curtailed';

  	if (props.type === 'full')
    classes = 'kt-header kt-grid__item  kt-header--fixed header-full';
  	else classes = 'kt-header kt-grid__item  kt-header--fixed header-curtailed';

	return (
		<React.Fragment>
		<div id="kt_header" className={classes}>
			<div className="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
				<div id="kt_header_menu" className="kt-header-menu kt-header-menu-mobile  kt-header-menu--layout-default">
					<h3 className="header-title">{props.title}</h3>

            {/* begin: DashBorad Dropdown */}
            {history.location.pathname === '/dashboard' && (
              <div className="kt-header__topbar">
                <div className="kt-header__topbar-item kt-header__topbar-item--langs margin-l20">
                  <div className="kt-header__topbar-wrapper">
                    <span className="kt-header__topbar-icon dashboardHeader">
                      <div className={`kt-margin-b-20-tablet-and-mobile`}>
                        <select                                              
                          className="form-control kt-selectpicker"
                          style={{ width: '150px' }}
                          id="ddlPeriod"
                          value={props.currentPeriod.id}
                          onChange={changePeriodHandler}>                                                        
                          {dashboardPeriods.map((s) => (
                            <option value={s.id} key={s.id}>
                              {s.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {props.currentPeriod.id == 6 && (
                        <React.Fragment>
                          <div className="margin-r10 margin-l10">
                            <input
                              id="fromDate"
                              value={moment(props.fromDate).format('YYYY-MM-DD') || ''}
                              max={moment().format('YYYY-MM-DD')}
                              name="fromDate"
                              className="form-control"
                              type="date"
                              onChange={(event) => props.setFromDate(event.target.value)}
                            />
                          </div>
                          <div className="margin-r10">
                            <label>To</label>
                          </div>
                          <input
                            id="toDate"
                            value={moment(props.toDate).format('YYYY-MM-DD') || ''}
                            max={moment().format('YYYY-MM-DD')}
                            name="toDate"
                            className="form-control"
                            type="date"
                            onChange={(event) => props.setToDate(event.target.value)}
                          />
                          <button className="btn btn-brand margin-l10" onClick={() => props.fetchPolicies(true)}>
                            <i className="la la-search"></i>
                          </button>
                        </React.Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* end: DashBorad Dropdown */}
          
        </div>

			<div className="kt-header__topbar">   
				{/* begin: Notification */}
				<div className="kt-header__topbar-item kt-header__topbar-item--langs mr-2">
					<div className="kt-header__topbar-wrapper" style={{ marginTop: '11px' }}>
						<span className="kt-nav__link" onClick={() => setshowNotification(true) } >
							<span className="kt-header__topbar-icon notifcation-bell" data-toggle="kt-tooltip" data-placement="bottom" data-original-title="Notifications" >
								<i className="flaticon2-bell-3"></i>
								{newAlertCount > 0 && (
									<span className="notification-badge">
										{ newAlertCount > 9 ? <span> 9+ </span>: <span> {newAlertCount} </span>} 
									</span>
								)}
							</span>
						</span>
					</div>  
				</div>
				{/* end: Notification */}

				{/* begin: Quick Action */}
				<div className="kt-header__topbar-item kt-header__topbar-item--langs mr-2">
					<div className="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px">
					<span className="kt-header__topbar-icon btn-quick-actions" data-toggle="kt-tooltip" data-placement="bottom" data-original-title="Quick Actions" style={{ borderRadius: '50%' }}>
						<img src={Bolt} alt="Quick-Actions" />
					</span>
					</div>
					<div className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
					<ul className="kt-nav kt-margin-t-10 kt-margin-b-10">
						<li className="kt-nav__item">
							<a onClick={() => showQuickModal('policy')} className="kt-nav__link">
								<span className="kt-nav__link-icon">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon" data-toggle="kt-tooltip" data-placement="right">
										<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<rect x="0" y="0" width="24" height="24"></rect>
											<rect fill="#000000" opacity="0.3" x="13" y="4" width="3" height="16" rx="1.5"></rect>
											<rect fill="#000000" x="8" y="9" width="3" height="11" rx="1.5"></rect>
											<rect fill="#000000" x="18" y="11" width="3" height="9" rx="1.5"></rect>
											<rect fill="#000000" x="3" y="13" width="3" height="7" rx="1.5"></rect>
										</g>
									</svg>
								</span>
								<span className="kt-nav__link-text">Policy</span>
							</a>
						</li>
						<li className="kt-nav__item">
							<a onClick={() => showQuickModal('client')} className="kt-nav__link">
								<span className="kt-nav__link-icon">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon" data-toggle="kt-tooltip" data-placement="right">
										<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<polygon points="0 0 24 0 24 24 0 24" />
											<path d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
											<path d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z" fill="#000000" fillRule="nonzero"/>
										</g>
									</svg>
								</span>
								<span className="kt-nav__link-text">Client</span>
							</a>
						</li>
						<li className="kt-nav__item">
							<a onClick={() => showQuickModal('task')} className="kt-nav__link">
								<span className="kt-nav__link-icon">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon" data-toggle="kt-tooltip" data-placement="right">
										<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<rect x="0" y="0" width="24" height="24" />
											<path d="M7.14319965,19.3575259 C7.67122143,19.7615175 8.25104409,20.1012165 8.87097532,20.3649307 L7.89205065,22.0604779 C7.61590828,22.5387706 7.00431787,22.7026457 6.52602525,22.4265033 C6.04773263,22.150361 5.88385747,21.5387706 6.15999985,21.0604779 L7.14319965,19.3575259 Z M15.1367085,20.3616573 C15.756345,20.0972995 16.3358198,19.7569961 16.8634386,19.3524415 L17.8320512,21.0301278 C18.1081936,21.5084204 17.9443184,22.1200108 17.4660258,22.3961532 C16.9877332,22.6722956 16.3761428,22.5084204 16.1000004,22.0301278 L15.1367085,20.3616573 Z" fill="#000000"/>
											<path d="M12,21 C7.581722,21 4,17.418278 4,13 C4,8.581722 7.581722,5 12,5 C16.418278,5 20,8.581722 20,13 C20,17.418278 16.418278,21 12,21 Z M19.068812,3.25407593 L20.8181344,5.00339833 C21.4039208,5.58918477 21.4039208,6.53893224 20.8181344,7.12471868 C20.2323479,7.71050512 19.2826005,7.71050512 18.696814,7.12471868 L16.9474916,5.37539627 C16.3617052,4.78960984 16.3617052,3.83986237 16.9474916,3.25407593 C17.5332781,2.66828949 18.4830255,2.66828949 19.068812,3.25407593 Z M5.29862906,2.88207799 C5.8844155,2.29629155 6.83416297,2.29629155 7.41994941,2.88207799 C8.00573585,3.46786443 8.00573585,4.4176119 7.41994941,5.00339833 L5.29862906,7.12471868 C4.71284263,7.71050512 3.76309516,7.71050512 3.17730872,7.12471868 C2.59152228,6.53893224 2.59152228,5.58918477 3.17730872,5.00339833 L5.29862906,2.88207799 Z" fill="#000000" opacity="0.3"/>
											<path d="M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z" fill="#000000"/>
										</g>
									</svg>
								</span>
								<span className="kt-nav__link-text">Task</span>
							</a>
						</li>
						<li className="kt-nav__item">
							<a onClick={() => showQuickModal('file')} className="kt-nav__link">
								<span className="kt-nav__link-icon">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon">
										<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<polygon points="0 0 24 0 24 24 0 24" />
											<path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
											<rect fill="#000000" x="6" y="11" width="9" height="2" rx="1"/>
											<rect fill="#000000" x="6" y="15" width="5" height="2" rx="1"/>
										</g>
									</svg>
								</span>
								<span className="kt-nav__link-text">File</span>
							</a>
						</li>
						<li className="kt-nav__item">
							<a onClick={() => navigateTo('/batch-upload/policies/upload')} className="kt-nav__link">
								<span className="kt-nav__link-icon">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon">
										<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<rect x="0" y="0" width="24" height="24" />
											<path d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
											<rect fill="#000000" opacity="0.3" x="11" y="2" width="2" height="14" rx="1"/>
											<path d="M12.0362375,3.37797611 L7.70710678,7.70710678 C7.31658249,8.09763107 6.68341751,8.09763107 6.29289322,7.70710678 C5.90236893,7.31658249 5.90236893,6.68341751 6.29289322,6.29289322 L11.2928932,1.29289322 C11.6689749,0.916811528 12.2736364,0.900910387 12.6689647,1.25670585 L17.6689647,5.75670585 C18.0794748,6.12616487 18.1127532,6.75845471 17.7432941,7.16896473 C17.3738351,7.57947475 16.7415453,7.61275317 16.3310353,7.24329415 L12.0362375,3.37797611 Z" fill="#000000" fillRule="nonzero"/>
										</g>
									</svg>
								</span>
								<span className="kt-nav__link-text">
									Policy Data Upload
								</span>
							</a>
						</li>
						<li className="kt-nav__item">
							<a onClick={() => navigateTo('/batch-upload/clients/upload')} className="kt-nav__link">
								<span className="kt-nav__link-icon">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon">
										<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<rect x="0" y="0" width="24" height="24" />
											<path d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
											<rect fill="#000000" opacity="0.3" x="11" y="2" width="2" height="14" rx="1"/>
											<path d="M12.0362375,3.37797611 L7.70710678,7.70710678 C7.31658249,8.09763107 6.68341751,8.09763107 6.29289322,7.70710678 C5.90236893,7.31658249 5.90236893,6.68341751 6.29289322,6.29289322 L11.2928932,1.29289322 C11.6689749,0.916811528 12.2736364,0.900910387 12.6689647,1.25670585 L17.6689647,5.75670585 C18.0794748,6.12616487 18.1127532,6.75845471 17.7432941,7.16896473 C17.3738351,7.57947475 16.7415453,7.61275317 16.3310353,7.24329415 L12.0362375,3.37797611 Z" fill="#000000" fillRule="nonzero"/>
										</g>
									</svg>
								</span>
								<span className="kt-nav__link-text">
									Client Data Upload
								</span>
							</a>
						</li>
					</ul>
					</div>
				</div>
				{/* end: Quick Action */}

				{/* begin: Search */}
				<div className="kt-header__topbar-item kt-header__topbar-item--langs mr-2">
					<div
					className="kt-header__topbar-wrapper"
					data-offset="10px,0px"
					style={{ marginTop: '10px' }}>
					<span className="kt-nav__link">
						<span className="kt-header__topbar-icon" data-toggle="kt-tooltip" data-placement="bottom" data-original-title="Search Policy" onClick={openSearchPolicyHandler}>
							<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon">
								<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
									<rect x="0" y="0" width="24" height="24" />
									<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
									<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fillRule="nonzero"/>
								</g>
							</svg>
						</span>
					</span>
					</div>
				</div>
				{/* end: Search */}

				{/* begin: User Bar */}
				<div id="kt-header-user-dropdown" className="kt-header__topbar-item kt-header__topbar-item--user">
					<div className="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px">
						<div className="kt-header__topbar-user">
							<span className="kt-header__topbar-welcome kt-hidden-mobile">
								Hi,
							</span>
							<span className="kt-header__topbar-username kt-hidden-mobile">
								{username}
							</span>
							<span className="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
								{username[0].toUpperCase()}
							</span>
						</div>
					</div>

					<div className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
						<div className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x padding-tb15 padding-r30">           
							<div className="kt-user-card-v2">
								<div className="kt-user-card-v2__pic margin-r10">
									{profilePhoto ?
									<img src={profilePhoto} alt="profile-image"/>
									:<div className="kt-badge kt-badge--xl kt-badge--info">{username[0].toUpperCase()}</div>
									}
								</div>
								<div className="kt-user-card-v2__details">
									<span className="kt-user-card-v2__name">{fullName}</span><span className="kt-user-card-v2__desc margin-t0"><small>{email}<br/>{companyName}</small></span>
								</div>
							</div>
						</div>
						{isAdmin && subscription && (
							<div className="kt-user-plan kt-notification-item-padding-x padding-tb15 padding-r30">
								<div className="kt-user-plan__head">
									<div>
										<span className="kt-user-plan__label">Current Plan</span>
										<span className="kt-user-plan__name">{subscription.planName}</span>
									</div>
									{subscription.effectivePlanCode !== 'ENTERPRISE' && (
										<button
											type="button"
											className="btn btn-outline-brand btn-pill btn-sm kt-user-plan__upgrade-btn"
											onClick={() => navigateTo('/billing/plans')}
										>
											Upgrade
										</button>
									)}
								</div>

								{usage && (
									<div className="kt-user-plan__usage">
										<div className="kt-user-plan__usage-row">
											<span className="kt-user-plan__usage-label">Policies</span>
											<span className="kt-user-plan__usage-value">
												{usage.policies.used} / {usage.policies.limit != null ? usage.policies.limit : '∞'}
											</span>
										</div>
										<div className="progress kt-user-plan__bar">
											<div
												className={`progress-bar ${isOverQuota(usage.policies.used, usage.policies.limit) ? 'kt-bg-danger' : 'kt-user-plan__bar-fill'}`}
												role="progressbar"
												style={{ width: `${usagePercent(usage.policies.used, usage.policies.limit) ?? 0}%` }}
											/>
										</div>

										<div className="kt-user-plan__usage-row margin-t10">
											<span className="kt-user-plan__usage-label">Storage</span>
											<span className="kt-user-plan__usage-value">
												{formatBytes(usage.files.used)} / {usage.files.limit != null ? formatBytes(usage.files.limit) : '∞'}
											</span>
										</div>
										<div className="progress kt-user-plan__bar">
											<div
												className={`progress-bar ${isOverQuota(usage.files.used, usage.files.limit) ? 'kt-bg-danger' : 'kt-user-plan__bar-fill'}`}
												role="progressbar"
												style={{ width: `${usagePercent(usage.files.used, usage.files.limit) ?? 0}%` }}
											/>
										</div>
									</div>
								)}
							</div>
						)}
						<div className="kt-notification">
							<MenuItem
								to="/profile"
								title="My Profile"
								icon={<ProfileIcon />}
							/>

							{isAdmin && (
								<>
									<MenuItem
										to="/billing/overview"
										title="Billing"
										icon={<BillingIcon />}
									/>
									<MenuItem
										to="/usage"
										title="Usage"
										icon={<UsageIcon />}
									/>
								</>
							)}

							<MenuItem
								to="/report"
								title="Support"
								icon={<SupportIcon />}
							/>


							<div className="kt-notification__custom kt-space-between padding-tb10">
								<button
									type="button"
									onClick={logout}
									className="btn btn-label btn-label-brand btn-sm btn-bold"
								>
								Sign Out
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* end: User Bar */}
			</div>
		</div>
		{showNotification && (
			<NotificationPanel 
				show = {showNotification}
				onCloseDrawer = {closeDrawerHandler}
				NotificationList = {notificationsList}
				setRefetch = {(v) => setrefetchNotifications(v)}
			/>
		)}  

		{showLicenseModal && (
			<LicenseModal
				show 		   = {showLicenseModal}
				onDismissModal = {() => setShowLicenseModal(false)}
			/>
		)}
		{showLicenseChangeReminder && (
			<LicenseChangeReminder
				show 		   = {showLicenseChangeReminder}
				onDismissModal = {() => setShowLicenseChangeReminder(false)}
			/>
		)}

		</React.Fragment>
	);
};

export default header;
